import { UseQueryResult, useQuery } from "@tanstack/react-query"
import usePrivateAxios from "@/common/api/usePrivateAxios"
import type { CompanyEventGroupedFee } from "../types/companyEventGroupedFee.type"

export const useCompanyGroupedFee: (id: string, enabled?: boolean) => UseQueryResult<CompanyEventGroupedFee[], unknown> = (id, enabled = false) => {
  const privateAxios = usePrivateAxios()
  return useQuery<{ data: { data: CompanyEventGroupedFee[] } }, unknown, CompanyEventGroupedFee[]>({
    queryKey: ['companyGroupedFee', id],
    queryFn: () => privateAxios.get(`/billing/events/${id}/fees`),
    enabled: enabled,
    select: response => response.data.data
  })
}
